import React from 'react'
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

import Text from './form-text'
import List from '../list/list'

import './form.styl'
import './form-search.styl'

let children = node => node?[...ReactDOM.findDOMNode(node).children]:[]

class Search extends React.Component {
    static propTypes = {
        label: PropTypes.string,
        value: PropTypes.string,
        onChange: PropTypes.func.isRequired,
        onSelect: PropTypes.func.isRequired
    }

    static defaultProps = {
        errorStr: 'app.error'
    }

    static WAIT_IN_MS = 1000;
    static PANEL_ID = 0;

    constructor(props){
        super(props);
        this.state = {
            over: false,
            value: props.value || ''
        }

        let printCollection = (over, e) => {
            e && e.preventDefault();
            this.state.over!==over && this.setState({over});
        }
        this.onClick = this.onClick.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onMouseOver = (e) => printCollection(true, e)
        this.onMouseEnter = (e) => printCollection(true, e)
        this.onMouseLeave = (e) => printCollection(false, e)
        this.onMouseClick = (e) => printCollection(false, e)
        this.sidePanelContainerId = 'sidePanel-search-' + Search.PANEL_ID++;
    }

    onChange(value) {
        this.state.value = value
        let { onChange = e => Promise.resolve(e) } = this.props
        let attr = element => ({ key: element.id, onClick: this.onClick(element) });
        let createInput = element => React.createElement('li', attr(element), element.label || element.title)
        let promise = onChange(value) || Promise.resolve(value)

        !promise._state && this.setState({loading: true, error: false, over:false, list:false})
        promise
            //html collection
            .then(data => data.collection.map(createInput))
            //collection to component list
            .then(collection => React.createElement(List, {collection} ))
            //update state
            .then(list => this.setState({loading: false, error: false, over:true, list}))
            .catch(e => this.setState({loading: false, error: true, over:false, list:false}));
        return promise;
    }

    onClick(element) {
        return (e) => {
            this.onMouseLeave(e);
            this.props.onSelect(element)
            this.setState({value: element.label, error: false, over:false})
        }
    }

    componentDidMount() {
        // let children = node => [...ReactDOM.findDOMNode(node).children]
        // let hasChildren = node => Array.isArray(children(node))
        // let aplatir = nodes => nodes.reduce((a, b) => hasChildren(b) ? a.concat(b).concat(aplatir(children(b))) : a.concat(b), []);
        // let inputNode = nodes.find( n => n.nodeName === 'INPUT')
        //console.log(aplatir(children(this.textNode)))

        //add event only on the first input (= search input)
        let findInput = array => array.find( n => n.nodeName === 'INPUT' )
        let input = array => array.reduce((a, b) => a.concat( findInput(children(b)) || input(children(b)) ), []);
        let node = input(children(this.refs.textNode))[0];
        node.addEventListener('mouseover', this.onMouseOver);
        node.addEventListener('mouseenter', this.onMouseEnter);
        node.addEventListener('mouseleave', this.onMouseLeave);
        node.addEventListener('mouseclick', this.onMouseClick);
    }

    render() {
        let { label, errorStr, placeholder } = this.props;
        let { list, loading, over, value } = this.state;
        let { onChange, onMouseOver, onMouseEnter, onMouseLeave, onMouseClick  } = this;


        return <div className="form form-search">
            <Text ref="textNode" label={label} value={value} onChange={onChange} disabled={loading} waitInMs={Search.WAIT_IN_MS} />
            <div className={'form-search-result' + (list && over ? ' opened' : '')} {...{onMouseOver, onMouseEnter, onMouseLeave, onClick: onMouseClick}} >
                { list && <div className="panel">
                    {list}
                </div>}
            </div>
        </div>
    }
}

export default Search
